import { gql } from 'apollo-boost';

export const newNotificationRule = gql`
mutation newNotificationRule(
  $name: String!,
  $ruleTrigger: Int!
  $ruleTriggerOptions: String,
  $template: Int,
  $deliveryImmediate: Boolean,
  $deliveryDigest: Boolean,
  $deliveryDigestAt: String,
  $deliveryDigestWeekday: String,
  $recipientIncludeNpo: Boolean,
  $recipientIncludePortfolioManager: Boolean,
  $recipientIncludeProgramManager: Boolean,
  $recipientIncludeAllNpoUsers: Boolean,
  $timingList: String
) {
newNotificationRule(
  name: $name,
  ruleTrigger: $ruleTrigger,
  ruleTriggerOptions: $ruleTriggerOptions,
  template: $template,
  deliveryImmediate: $deliveryImmediate,
  deliveryDigest: $deliveryDigest,
  deliveryDigestAt: $deliveryDigestAt,
  deliveryDigestWeekday: $deliveryDigestWeekday,
  recipientIncludeNpo: $recipientIncludeNpo,
  recipientIncludePortfolioManager: $recipientIncludePortfolioManager,
  recipientIncludeProgramManager: $recipientIncludeProgramManager,
  recipientIncludeAllNpoUsers: $recipientIncludeAllNpoUsers,
  timingList: $timingList
) {
    success
    id
  }
}
`;
